export const REMIT = 'remit';
export const QRCODE = 'qrcode';
export const ONLINE = 'online';
export const QUICK = 'quick';
